// 主路由
const main = [
  {
    path: '/',
    redirect: '/list'
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('@/views/ErrorBoundary' /* webpackChunkName: "error" */)
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      brand: true
    },
    component: () => import('@/views/Login' /* webpackChunkName: "login" */)
  },
  {
    path: '/test',
    name: 'test',
    meta: {
      needLogin: true,
      dialogLogin: true
    },
    component: () => import('@/views/Test' /* webpackChunkName: "test" */)
  },
  {
    path: '/pretest',
    name: 'pretest',
    meta: {
      needLogin: true
    },
    component: () => import('@/views/Pretest' /* webpackChunkName: "pretest" */)
  },
  {
    path: '/list',
    name: 'list',
    meta: {
      needLogin: true
    },
    component: () => import('@/views/List' /* webpackChunkName: "list" */)
  },
  {
    path: '/touristsmsg',
    name: 'touristsmsg',
    component: () => import('@/views/touristsPage' /* webpackChunkName: "list" */)
  },
  {
    path: '/thirdLogin',
    name: 'thirdLogin',
    component: () =>
      import('@/views/Login/ThirdLogin' /* webpackChunkName: "thirdLogin" */),
    meta: {
      layout: 'Noop'
    }
  },
  {
    path: '/showPaper',
    name: 'showPaper',
    // meta: {
    //   needLogin: true
    // },
    component: () => import('@/views/ExamineePaperView' /* webpackChunkName: "showPaper" */)
  },
  {
    path: '/jumpPage',
    name: 'jumpPage',
    component: () => import('@/views/jumpPage' /* webpackChunkName: "jumpPage" */)
  },
  {
    path: '/detect',
    name: 'detect',
    component: () => import('@/views/Detect' /* webpackChunkName: "detect" */),
    meta: {
      needLogin: true,
      layout: 'Noop'
    }
  },
  {
    path: '/identityCheck',
    name: 'identityCheck',
    component: () => import('@/views/IdentityCheck' /* webpackChunkName: "IdentityCheck" */),
    meta: {
      needLogin: true,
      layout: 'Noop'
    }
  }
]

export default main
